const OurServices = () => {
  return (
    <section id="service" className="section-padding">
      <div className="container mb-60 text-center">
        <h2>
          Our <span className="text-light">Services</span>
        </h2>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 col-sm-12 pt-30 pt-sm-0">
            <div
              className="content-box right wow fadeIn"
              style={{ paddingRight: 0 }}
              data-wow-delay="0.2s"
              data-wow-duration="2s"
            >
              <h5 className="features-title" style={{ fontSize: 18 }}>
                Consultation & Business Process Analysis
              </h5>
              <p style={{ fontSize: 16 }}>
                Understanding company workflows, pain points, and system needs.
              </p>
            </div>
            <div
              className="content-box right wow fadeIn"
              style={{ paddingRight: 0 }}
              data-wow-delay="0.2s"
              data-wow-duration="4s"
            >
              <h5 className="features-title" style={{ fontSize: 18 }}>
                Module-Based ERP Implementation
              </h5>
              <p style={{ fontSize: 16 }}>
                Developing individual ERP components (HR, Accounting, CRM,
                etc.).
              </p>
            </div>
            <div
              className="content-box right wow fadeIn"
              style={{ paddingRight: 0 }}
              data-wow-delay="0.2s"
              data-wow-duration="6s"
            >
              <h5 className="features-title" style={{ fontSize: 18 }}>
                ERP Integration Services
              </h5>
              <p style={{ fontSize: 16 }}>
                Connecting ERP with third-party tools like Salesforce,
                QuickBooks, SAP, etc.
              </p>
            </div>
            <div
              className="content-box right wow fadeIn"
              style={{ paddingRight: 0 }}
              data-wow-delay="0.2s"
              data-wow-duration="8s"
            >
              <h5 className="features-title" style={{ fontSize: 18 }}>
                Cloud & On-Premise ERP Deployment
              </h5>
              <p style={{ fontSize: 16 }}>
                Offering flexible hosting based on business needs.
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 d-lg-block d-sm-none .d-md-none text-center">
            <img
              src="/img/services-img.jpg"
              style={{ width: "100%", borderRadius: 10, paddingBottom: 15 }}
              alt=""
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 pt-30 pt-sm-0">
            <div
              className="content-box left wow fadeIn"
              style={{ paddingLeft: 0 }}
              data-wow-delay="0.2s"
              data-wow-duration="2s"
            >
              <h5 className="features-title" style={{ fontSize: 18 }}>
                Custom ERP Software Development
              </h5>
              <p style={{ fontSize: 16 }}>
                Full-cycle development of modular, scalable, and secure ERP
                solutions.
              </p>
            </div>
            <div
              className="content-box left wow fadeIn"
              style={{ paddingLeft: 0 }}
              data-wow-delay="0.4s"
              data-wow-duration="2s"
            >
              <h5 className="features-title" style={{ fontSize: 18 }}>
                Training & Support
              </h5>
              <p style={{ fontSize: 16 }}>
                Comprehensive user training, documentation, and 24/7 technical
                assistance.
              </p>
            </div>
            <div
              className="content-box left wow fadeIn"
              style={{ paddingLeft: 0 }}
              data-wow-delay="0.6s"
              data-wow-duration="2s"
            >
              <h5 className="features-title" style={{ fontSize: 18 }}>
                AI & ML Integration
              </h5>
              <p style={{ fontSize: 16 }}>
                Predictive analytics, automation, NLP- driven chatbots, fraud
                detection.
              </p>
            </div>
            <div
              className="content-box left wow fadeIn"
              style={{ paddingLeft: 0 }}
              data-wow-delay="0.8s"
              data-wow-duration="2s"
            >
              <h5 className="features-title" style={{ fontSize: 18 }}>
                Advanced Business Intelligence (BI) & Analytics
              </h5>
              <p style={{ fontSize: 16 }}>
                Data-driven insights with AI-powered reporting tools.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurServices;
